const navigationItems = [
  {
    name: 'Products',
    link: null,
    children: [
      {
        name: 'bravoGROWTH',
        link: '/growth'
      },
      {
        name: 'bravoTALENT',
        link: '/talent'
      },
      {
        name: 'bravoSURVEYS',
        link: '/surveys'
      },
      {
        name: 'bravoINSIGHTS',
        link: '/pricing'
      }
    ]
  },
  {
    name: 'Pricing',
    link: '/pricing'
  },
  {
    name: 'Blog',
    link: '/blog'
  },
  {
    name: 'About',
    link: null,
    children: [
      {
        name: 'About bravoSUITE',
        link: '/about-us'
      },
      {
        name: 'News',
        link: '/news'
      },
      {
        name: 'Careers',
        link: 'https://jobs.bravosuite.io/'
      }
    ]
  },
  {
    name: 'Contact',
    link: '/contact-us'
  }
];

export { navigationItems };
